import { styled } from "@linaria/react"

export const Subheading = styled.div`
  color: var(--mui-palette-text-secondary);
  margin: 0;
  padding: calc(var(--spacing) * 0.25);
`
